import { generatePath, RouteMap, useParams } from 'lib/router'
import MerchantList from '../views/MerchantList'
import { useStore } from '../state/store'
import Loading from 'components/Loading'

export const MerchantListContainer = ({ routes }: { routes: RouteMap }) => {
  const workspaceId = useStore(state => state.workspace.id)
  const organizationId = useStore(state => state.organization.id)
  const { listId } = useParams<{ listId: string }>()

  if (!workspaceId || !organizationId || !listId) {
    return <Loading />
  }

  return (
    <MerchantList
      merchantListId={listId}
      workspaceId={workspaceId}
      organizationId={organizationId}
      tabPaths={routes.map(route =>
        generatePath(route.path, { workspaceId, listId })
      )}
    />
  )
}
